import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PurposeEffects, purposeReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([PurposeEffects]), StoreModule.forFeature(`purpose`, purposeReducer)]
})
export class PurposeStateModule {}
